export default "__VITE_ASSET__Cvd9n$Ky__"